import { FormlyFieldConfig, FormlyExtension } from '@ngx-formly/core';

export class PrependAppendFormlyExtension implements FormlyExtension {
  onPopulate(field: FormlyFieldConfig) {
    if (
      !field.props ||
      (field.wrappers && field.wrappers.indexOf('prepend-append') !== -1)
    ) {
      return;
    }

    if (field.props['prepend'] || field.props['append']) {
      field.wrappers = [...(field.wrappers || []), 'prepend-append'];
    }
  }
}
